import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  downloadDutySlip,
  downloadInvoice,
  buildInvoiceHtml,
  buildLogoUrl,
  fetchRestCompany,
} from '../../../utils/dashboardPdfHelper';

const BASE_API_URL = (process.env.REACT_APP_BASE_API_URL || 'http://localhost:5000/api').replace(/\/api\/?$/, '') + '/api';

const PdfPreviewModal = ({ isOpen, type, data, onClose, onDownloadWithProgress }) => {
  const [loading, setLoading] = useState(true);
  const [details, setDetails] = useState(null);
  const [companyInfo, setCompanyInfo] = useState({});
  const [bankInfo, setBankInfo] = useState(null);

  useEffect(() => {
    if (!isOpen || !data) return;

    let isMounted = true;
    setLoading(true);
    setDetails(null);

    const selectedCompany = JSON.parse(localStorage.getItem('selectedCompany')) || {};
    const compId = localStorage.getItem('companyId') || selectedCompany.id || selectedCompany.CompID || 1147;

    const fetchDetails = async () => {
      try {
        if (compId) {
          let cData = {};
          try {
            const cRes = await axios.get(`${BASE_API_URL}/invoice/company/${compId}`, { timeout: 5000 });
            if (cRes.data?.success) {
              cData = cRes.data.data || {};
            }
          } catch (_) {}
          try {
            const restCData = await fetchRestCompany(compId);
            cData = {
              ...restCData,
              ...cData,
              LogoPath: cData.LogoPath || cData.Logopath || cData.logoPath || restCData.LogoPath,
            };
          } catch (_) {}
          if (isMounted) {
            setCompanyInfo(cData);
          }
        }

        if (type === 'dutyslip') {
          const rawId = String(data?.id || data?.dsNo || data?.DutyslipID || data?.BookingID || data?.dutySlipId || '').replace(/^DS-?/i, '').trim();
          if (rawId) {
            try {
              const dsRes = await axios.get(`${BASE_API_URL}/dutyslip/dutyslip?id=${rawId}`);
              if (dsRes.data?.success && Array.isArray(dsRes.data?.data) && dsRes.data.data.length > 0 && isMounted) {
                setDetails({ ...data, ...dsRes.data.data[0] });
                return;
              }
            } catch (err) {
              console.warn('Error fetching duty slip details by ID:', err);
            }
          }
          if (isMounted) setDetails(data);
        } else if (type === 'invoice') {
          const invNo = String(data.InvoiceNo || data.invId || data.invoiceNo || '').trim();
          if (invNo && compId) {
            let invFull = data;
            try {
              const invRes = await axios.get(`${BASE_API_URL}/invoice/details/${compId}?invoiceNo=${encodeURIComponent(invNo)}`);
              if (invRes.data?.data || invRes.data?.invoice) {
                const fetched = invRes.data.data || invRes.data.invoice || {};
                invFull = {
                  ...data,
                  ...fetched,
                };
                [
                  "State", "state", "StateName", "stateName", "StateCode", "stateCode",
                  "Address", "address", "PartyAddress", "partyAddress",
                  "GSTIN", "gstin", "PartyGSTIN", "partyGSTIN", "GstNo",
                  "VehicleNo", "vehicleNo", "VehicleType", "vehicleType",
                  "DriverName", "driverName", "Guest", "guest", "BookedBy", "bookedBy",
                  "ReverseCharge", "reverseCharge", "ReverseCharges",
                ].forEach((f) => {
                  if ((invFull[f] === undefined || invFull[f] === null || invFull[f] === "") && data[f]) {
                    invFull[f] = data[f];
                  }
                });
                if (data.State || data.state || data.StateName) {
                  invFull.State = data.State || data.state || data.StateName;
                }
                if (data.StateCode || data.stateCode) {
                  invFull.StateCode = data.StateCode || data.stateCode;
                }
                if (data.Address || data.address || data.PartyAddress) {
                  invFull.Address = data.Address || data.address || data.PartyAddress;
                }
                if (data.GSTIN || data.gstin || data.PartyGSTIN) {
                  invFull.GSTIN = data.GSTIN || data.gstin || data.PartyGSTIN;
                }
              }
            } catch (err) {
              console.warn('Error fetching invoice details:', err);
            }

            const pName = invFull.PartyName || invFull.company || invFull.partyName;
            if (pName && (!invFull.State || !invFull.StateCode || !invFull.Address || !invFull.GSTIN)) {
              try {
                const partyRes = await axios.get(
                  `${BASE_API_URL}/invoice/dropdowns/details/${compId}?headName=${encodeURIComponent(pName)}`
                );
                if (partyRes.data?.success && partyRes.data?.data) {
                  const p = partyRes.data.data;
                  if (!invFull.State && !invFull.state) invFull.State = p.StateName || p.State || "";
                  if (!invFull.StateCode && !invFull.stateCode) invFull.StateCode = p.StateCode || "";
                  if (!invFull.Address && !invFull.address && !invFull.PartyAddress) invFull.Address = p.ADDRESS1 || p.Address || "";
                  if (!invFull.GSTIN && !invFull.gstin && !invFull.PartyGSTIN && !invFull.GstNo) invFull.GSTIN = p.GSTNO || p.GstNo || "";
                }
              } catch (err) {
                console.warn("Could not fetch party fallback details for invoice preview", err);
              }
            }

            if (isMounted) {
              setDetails(invFull);
            }

            try {
              const bRes = await axios.get(`${BASE_API_URL}/company/bank-details/${compId}`);
              if (bRes.data?.success && isMounted) {
                setBankInfo(bRes.data.data);
              }
            } catch (_) {}
            return;
          }
          if (isMounted) setDetails(data);
        }
      } catch (err) {
        console.warn('Error fetching preview details:', err);
        if (isMounted) setDetails(data);
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchDetails();

    return () => {
      isMounted = false;
    };
  }, [isOpen, type, data]);

  if (!isOpen || !data) return null;

  const selectedCompany = JSON.parse(localStorage.getItem('selectedCompany')) || {};
  const companyName = companyInfo.Name || companyInfo.name || selectedCompany.Name || selectedCompany.name || "DAZY TOURE TRAVEL'S";
  const companyAddress = companyInfo.Address || companyInfo.address || selectedCompany.Address || selectedCompany.address || 'Sahakar Marg';
  const companyColor = companyInfo.CompanyColourCode || companyInfo.companyColourCode || selectedCompany.CompanyColourCode || selectedCompany.companyColourCode || '#000000';

  const companyLogoUrl = buildLogoUrl(
    companyInfo.LogoPath ||
    companyInfo.Logopath ||
    companyInfo.logoPath ||
    selectedCompany.LogoPath ||
    selectedCompany.Logopath ||
    selectedCompany.logoPath
  );

  const handlePrint = () => {
    const isDutySlip = type === 'dutyslip';
    const printContent = isDutySlip
      ? document.getElementById('duty-slip-preview-render')
      : document.getElementById('invoice-preview-render');

    if (!printContent) {
      window.print();
      return;
    }
    const printWindow = window.open('', '_blank', 'width=1100,height=800');
    if (!printWindow) {
      window.print();
      return;
    }
    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>${isDutySlip ? `Duty Slip ${details?.id || data?.id || ''}` : `Tax Invoice ${details?.InvoiceNo || data?.InvoiceNo || data?.invId || ''}`}</title>
          <style>
            @page { size: ${isDutySlip ? 'landscape' : 'portrait'}; margin: 8mm; }
            body { margin: 0; padding: 12px; font-family: Arial, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif; background: #fff; color: #000; }
            * { box-sizing: border-box; }
            table { border-collapse: collapse; width: 100%; }
          </style>
        </head>
        <body>
          ${printContent.innerHTML}
          <script>
            window.onload = function() {
              window.print();
              setTimeout(() => { window.close(); }, 500);
            };
          </script>
        </body>
      </html>
    `);
    printWindow.document.close();
  };

  const handleDownload = () => {
    if (type === 'dutyslip') {
      if (onDownloadWithProgress) {
        onDownloadWithProgress('dutyslip', details || data);
      } else {
        downloadDutySlip(details || data);
      }
    } else {
      if (onDownloadWithProgress) {
        onDownloadWithProgress('invoice', details || data);
      } else {
        downloadInvoice(details || data);
      }
    }
  };

  const formatKmCell = (val) => {
    if (val === null || val === undefined || val === '' || val === '0' || val === 0 || Number(val) === 0) {
      return '';
    }
    return String(val);
  };

  const formatTimeCell = (val) => {
    if (!val || val === '-' || val === '12:00 AM' || val === '12:00 am' || val === '12:00PM' || val === '00:00' || val === '0h 0m' || val === '0h' || val === '0.00' || val === '0' || val === 0) {
      return '';
    }
    return String(val);
  };

  const formatDate = (dateStr) => {
    if (!dateStr || dateStr === 'null' || dateStr === 'undefined' || dateStr === '-') return '-';
    try {
      const str = String(dateStr).trim();
      if (/^\d{1,2}[-/]\d{1,2}[-/]\d{4}$/.test(str)) {
        const parts = str.split(/[-/]/);
        return `${String(parts[0]).padStart(2, '0')}-${String(parts[1]).padStart(2, '0')}-${parts[2]}`;
      }
      if (/^\d{4}[-/]\d{1,2}[-/]\d{1,2}/.test(str)) {
        const parts = str.split('T')[0].split(' ')[0].split(/[-/]/);
        return `${String(parts[2]).padStart(2, '0')}-${String(parts[1]).padStart(2, '0')}-${parts[0]}`;
      }
      const d = new Date(str);
      if (!isNaN(d.getTime())) {
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
      }
      return str;
    } catch (_) {
      return String(dateStr);
    }
  };

  const slipId = String(details?.id || details?.DutyslipID || details?.SlipNo || data?.id || data?.dsNo || '').replace(/^DS-?/i, '');
  const taxiDisplay =
    (details?.VehicleType || details?.vehicleType || details?.vehicle || data?.vehicle || '') &&
    (details?.VehicleNo || details?.vehicleNo || data?.vehicleNo || '')
      ? `${details?.VehicleType || details?.vehicleType || details?.vehicle || data?.vehicle} - ${details?.VehicleNo || details?.vehicleNo || data?.vehicleNo}`
      : (details?.VehicleType || details?.vehicleType || details?.vehicle || details?.VehicleNo || details?.vehicleNo || data?.vehicle || '-');

  const hired = details?.PartyName || details?.partyName || data?.company || '-';
  const client = details?.ClientName || details?.guestName || details?.bookedBy || data?.bookedBy || '-';
  const address = details?.ClientAddress || details?.partyAddress || details?.address || data?.address || '-';
  const driverName = details?.DriverName || details?.driverName || data?.driverName || '-';
  const mobileNo = details?.Mobile || details?.mobile || details?.partyMobile || details?.hiredMobile || data?.mobile || '-';
  const packageName = details?.PackageName || details?.packageName || data?.packageName || '-';
  const totalKm = details?.TotalKM ?? details?.totalKm ?? data?.totalKm ?? '';
  const totalTime = details?.TotalTime || details?.totalTime || data?.totalTime || '';

  const dsRows = Array.isArray(details?.dateWiseDetails) && details.dateWiseDetails.length > 0
    ? details.dateWiseDetails
    : [
        {
          date: details?.DutyslipDate || details?.slipDate || details?.StartDate || details?.date || data?.date,
          kmStartGarage: details?.KMStart ?? details?.kmStart ?? data?.kmStart ?? '',
          kmStartUser: details?.KMStart ?? details?.kmStart ?? data?.kmStart ?? '',
          kmClose: details?.KMClose ?? details?.kmEnd ?? data?.kmEnd ?? '',
          kmCloseGarage: details?.KMClose ?? details?.kmEnd ?? data?.kmEnd ?? '',
          totalKm: totalKm,
          openingTime: details?.time12 || details?.openTime12 || details?.OpnTime || data?.OpnTime || '',
          closingTime: details?.endTime12 || details?.closeTime12 || details?.CloseTime || data?.CloseTime || '',
          totalTime: totalTime,
          tripDetails: details?.tripDetails || details?.TripDetails || details?.route || data?.tripDetails || '',
          packageName: packageName,
        },
      ];

  const blankRowsCount = Math.max(0, 5 - dsRows.length);

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(15, 23, 42, 0.7)',
        backdropFilter: 'blur(3px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 999999,
        padding: '16px'
      }}
      onClick={onClose}
    >
      <div
        style={{
          backgroundColor: '#ffffff',
          borderRadius: '10px',
          maxWidth: type === 'dutyslip' ? '1080px' : '880px',
          width: '100%',
          maxHeight: '94vh',
          boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.35)',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          style={{
            backgroundColor: '#064e48',
            color: '#ffffff',
            padding: '14px 20px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            borderTopLeftRadius: '10px',
            borderTopRightRadius: '10px'
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <h3 style={{ margin: 0, fontSize: '17px', fontWeight: '700', letterSpacing: '0.3px', color: '#ffffff' }}>
              {type === 'dutyslip'
                ? `Duty Slip Preview - #${slipId || data?.id || data?.dsNo}`
                : `Tax Invoice Preview - #${details?.InvoiceNo || data?.invId || data?.InvoiceNo || ''}`}
            </h3>
          </div>
          <button
            onClick={onClose}
            style={{
              background: 'rgba(255, 255, 255, 0.15)',
              border: 'none',
              borderRadius: '6px',
              color: '#ffffff',
              width: '32px',
              height: '32px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '16px',
              transition: 'background 0.2s'
            }}
            onMouseOver={(e) => (e.currentTarget.style.background = 'rgba(255, 255, 255, 0.3)')}
            onMouseOut={(e) => (e.currentTarget.style.background = 'rgba(255, 255, 255, 0.15)')}
          >
            ✕
          </button>
        </div>

        <div
          style={{
            padding: '10px 20px',
            backgroundColor: '#f8fafc',
            borderBottom: '1px solid #e2e8f0',
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            gap: '12px'
          }}
        >
          <button
            onClick={handlePrint}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              padding: '6px 14px',
              fontSize: '13px',
              fontWeight: '600',
              color: '#334155',
              backgroundColor: '#ffffff',
              border: '1px solid #cbd5e1',
              borderRadius: '6px',
              cursor: 'pointer'
            }}
          >
            Print
          </button>
          <button
            onClick={handleDownload}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              padding: '6px 14px',
              fontSize: '13px',
              fontWeight: '600',
              color: '#ffffff',
              backgroundColor: '#064e48',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer'
            }}
          >
            Download PDF
          </button>
        </div>

        <div
          style={{
            padding: '20px',
            overflowY: 'auto',
            flex: 1,
            backgroundColor: '#f1f5f9'
          }}
        >
          {loading ? (
            <div style={{ textAlign: 'center', padding: '60px 20px', color: '#64748b' }}>
              <div style={{ width: '28px', height: '28px', border: '3px solid #cbd5e1', borderTopColor: '#064e48', borderRadius: '50%', animation: 'spin 0.8s linear infinite', margin: '0 auto 10px' }}></div>
              <div style={{ fontSize: '13.5px', fontWeight: '500' }}>Loading document details...</div>
            </div>
          ) : type === 'dutyslip' ? (
            <div
              id="duty-slip-preview-render"
              style={{
                fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
                color: '#0f172a',
                padding: '24px',
                width: '1000px',
                boxSizing: 'border-box',
                background: '#ffffff',
                margin: '0 auto',
                borderRadius: '8px',
                boxShadow: '0 4px 20px rgba(0,0,0,0.08)'
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingBottom: '14px', borderBottom: '2px solid #000000', marginBottom: '16px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
                  <div style={{ width: '48px', height: '48px', background: '#000000', borderRadius: '6px', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden', flexShrink: 0 }}>
                    {companyLogoUrl ? (
                      <img
                        src={companyLogoUrl}
                        alt="Logo"
                        style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                        onError={(e) => {
                          e.currentTarget.style.display = 'none';
                        }}
                      />
                    ) : null}
                    <span style={{ color: '#ffffff', fontWeight: 800, fontSize: '16px', letterSpacing: '1px', display: companyLogoUrl ? 'none' : 'inline' }}>
                      {companyName.split(' ').map((w) => w[0]).join('').slice(0, 3).toUpperCase() || 'TRY'}
                    </span>
                  </div>
                  <div>
                    <div style={{ fontSize: '20px', fontWeight: 900, letterSpacing: '0.5px', textTransform: 'uppercase', color: companyColor || '#000000', lineHeight: 1.2 }}>
                      {companyName}
                    </div>
                    <div style={{ fontSize: '13px', color: '#64748b', fontWeight: 500, marginTop: '2px' }}>
                      {companyAddress}
                    </div>
                  </div>
                </div>
                <div style={{ fontSize: '22px', fontWeight: 900, textDecoration: 'underline', textUnderlineOffset: '4px', color: '#000000', letterSpacing: '1.5px' }}>
                  DUTY SLIP
                </div>
              </div>

              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: '1.5fr 1fr',
                  gap: '20px',
                  border: '1.5px solid #000000',
                  borderRadius: '12px',
                  padding: '14px 18px',
                  marginBottom: '16px',
                  background: '#ffffff',
                  fontSize: '13px',
                  lineHeight: 1.8
                }}
              >
                <div style={{ display: 'flex', flexDirection: 'column', gap: '3px' }}>
                  <div style={{ display: 'grid', gridTemplateColumns: '80px 1fr', alignItems: 'baseline' }}>
                    <span style={{ color: '#64748b', fontWeight: 500 }}>Sr No:</span>
                    <b style={{ color: '#000000', fontWeight: 800 }}>{slipId || '-'}</b>
                  </div>
                  <div style={{ display: 'grid', gridTemplateColumns: '80px 1fr', alignItems: 'baseline' }}>
                    <span style={{ color: '#64748b', fontWeight: 500 }}>Taxi No:</span>
                    <b style={{ color: '#000000', fontWeight: 800 }}>{taxiDisplay}</b>
                  </div>
                  <div style={{ display: 'grid', gridTemplateColumns: '80px 1fr', alignItems: 'baseline' }}>
                    <span style={{ color: '#64748b', fontWeight: 500 }}>Hired:</span>
                    <b style={{ color: '#000000', fontWeight: 800 }}>{hired}</b>
                  </div>
                  <div style={{ display: 'grid', gridTemplateColumns: '80px 1fr', alignItems: 'baseline' }}>
                    <span style={{ color: '#64748b', fontWeight: 500 }}>Client:</span>
                    <b style={{ color: '#000000', fontWeight: 800 }}>{client}</b>
                  </div>
                  <div style={{ display: 'grid', gridTemplateColumns: '80px 1fr', alignItems: 'baseline' }}>
                    <span style={{ color: '#64748b', fontWeight: 500 }}>Address:</span>
                    <b style={{ color: '#000000', fontWeight: 800, wordBreak: 'break-word' }}>{address}</b>
                  </div>
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '3px' }}>
                  <div style={{ display: 'grid', gridTemplateColumns: '85px 1fr', alignItems: 'baseline' }}>
                    <span style={{ color: '#64748b', fontWeight: 500 }}>Date:</span>
                    <b style={{ color: '#000000', fontWeight: 800 }}>{formatDate(dsRows[0]?.date)}</b>
                  </div>
                  <div style={{ display: 'grid', gridTemplateColumns: '85px 1fr', alignItems: 'baseline' }}>
                    <span style={{ color: '#64748b', fontWeight: 500 }}>Driver:</span>
                    <b style={{ color: '#000000', fontWeight: 800 }}>{driverName}</b>
                  </div>
                  <div style={{ display: 'grid', gridTemplateColumns: '85px 1fr', alignItems: 'baseline' }}>
                    <span style={{ color: '#64748b', fontWeight: 500 }}>Mobile No:</span>
                    <b style={{ color: '#000000', fontWeight: 800 }}>{mobileNo}</b>
                  </div>
                </div>
              </div>

              <div style={{ overflowX: 'auto', marginBottom: '16px' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'center', fontSize: '11px', tableLayout: 'fixed' }}>
                  <thead>
                    <tr style={{ backgroundColor: '#ffffff', fontWeight: '700' }}>
                      <th style={{ border: '1px solid #000000', padding: '6px 4px', width: '85px' }}>Date</th>
                      <th style={{ border: '1px solid #000000', padding: '6px 4px', width: '80px' }}>Start KM</th>
                      <th style={{ border: '1px solid #000000', padding: '6px 4px', width: '80px' }}>Close KM</th>
                      <th style={{ border: '1px solid #000000', padding: '6px 4px', width: '70px' }}>Total KM</th>
                      <th style={{ border: '1px solid #000000', padding: '6px 4px', width: '70px' }}>Opn Time</th>
                      <th style={{ border: '1px solid #000000', padding: '6px 4px', width: '70px' }}>Close Time</th>
                      <th style={{ border: '1px solid #000000', padding: '6px 4px', width: '70px' }}>Total Time</th>
                      <th style={{ border: '1px solid #000000', padding: '6px 6px', textAlign: 'left' }}>Trip Details</th>
                      <th style={{ border: '1px solid #000000', padding: '6px 6px', width: '130px', textAlign: 'left' }}>Package Name</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dsRows.map((row, idx) => (
                      <tr key={idx}>
                        <td style={{ border: '1px solid #000000', padding: '6px 4px', height: '26px' }}>{formatDate(row.date)}</td>
                        <td style={{ border: '1px solid #000000', padding: '6px 4px', height: '26px' }}>{formatKmCell(row.kmStartUser || row.kmStart || row.kmStartGarage)}</td>
                        <td style={{ border: '1px solid #000000', padding: '6px 4px', height: '26px' }}>{formatKmCell(row.kmClose || row.kmEnd || row.kmCloseGarage)}</td>
                        <td style={{ border: '1px solid #000000', padding: '6px 4px', height: '26px' }}>{formatKmCell(row.totalKm)}</td>
                        <td style={{ border: '1px solid #000000', padding: '6px 4px', height: '26px' }}>{formatTimeCell(row.openingTime)}</td>
                        <td style={{ border: '1px solid #000000', padding: '6px 4px', height: '26px' }}>{formatTimeCell(row.closingTime)}</td>
                        <td style={{ border: '1px solid #000000', padding: '6px 4px', height: '26px' }}>{formatTimeCell(row.totalTime)}</td>
                        <td style={{ border: '1px solid #000000', padding: '6px 6px', textAlign: 'left', height: '26px' }}>{row.tripDetails || ''}</td>
                        <td style={{ border: '1px solid #000000', padding: '6px 6px', textAlign: 'left', height: '26px' }}>{row.packageName || ''}</td>
                      </tr>
                    ))}
                    {Array.from({ length: blankRowsCount }).map((_, idx) => (
                      <tr key={`blank-${idx}`}>
                        <td style={{ border: '1px solid #000000', height: '26px' }}>&nbsp;</td>
                        <td style={{ border: '1px solid #000000', height: '26px' }}>&nbsp;</td>
                        <td style={{ border: '1px solid #000000', height: '26px' }}>&nbsp;</td>
                        <td style={{ border: '1px solid #000000', height: '26px' }}>&nbsp;</td>
                        <td style={{ border: '1px solid #000000', height: '26px' }}>&nbsp;</td>
                        <td style={{ border: '1px solid #000000', height: '26px' }}>&nbsp;</td>
                        <td style={{ border: '1px solid #000000', height: '26px' }}>&nbsp;</td>
                        <td style={{ border: '1px solid #000000', height: '26px' }}>&nbsp;</td>
                        <td style={{ border: '1px solid #000000', height: '26px' }}>&nbsp;</td>
                      </tr>
                    ))}
                    <tr style={{ fontWeight: '700', backgroundColor: '#f1f5f9' }}>
                      <td colSpan="3" style={{ textAlign: 'right', paddingRight: '16px', border: '1px solid #000000', borderTop: '2px solid #000000', fontSize: '12.5px' }}>Grand Total</td>
                      <td style={{ border: '1px solid #000000', borderTop: '2px solid #000000' }}>{formatKmCell(totalKm)}</td>
                      <td colSpan="2" style={{ border: '1px solid #000000', borderTop: '2px solid #000000' }}></td>
                      <td style={{ border: '1px solid #000000', borderTop: '2px solid #000000' }}>{formatTimeCell(totalTime)}</td>
                      <td colSpan="2" style={{ border: '1px solid #000000', borderTop: '2px solid #000000' }}></td>
                    </tr>
                  </tbody>
                </table>
              </div>

              {/* Signature area */}
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginTop: '24px', padding: '0 4px' }}>
                <div style={{ width: '44%' }}>
                  <div style={{ fontWeight: 700, fontSize: '14px', textDecoration: 'underline', textUnderlineOffset: '3px', color: '#1e293b', marginBottom: '6px' }}>Signature</div>
                  <div style={{ borderBottom: '2px solid #000000', width: '100%', marginTop: '6px' }}></div>
                </div>
                <div style={{ width: '44%' }}>
                  <div style={{ fontWeight: 700, fontSize: '14px', textDecoration: 'underline', textUnderlineOffset: '3px', color: '#1e293b', marginBottom: '6px' }}>Remark</div>
                  <div style={{ borderBottom: '2px solid #000000', width: '100%', marginTop: '6px' }}></div>
                  <div style={{ borderBottom: '2px solid #000000', width: '100%', marginTop: '28px' }}></div>
                </div>
              </div>
            </div>
          ) : (
            <div
              id="invoice-preview-render"
              style={{
                backgroundColor: '#ffffff',
                borderRadius: '8px',
                padding: '16px',
                boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                overflowX: 'auto',
                display: 'flex',
                justifyContent: 'center',
              }}
              dangerouslySetInnerHTML={{
                __html: buildInvoiceHtml({
                  fullInvoice: details || data,
                  companyData: companyInfo,
                  bankData: bankInfo,
                  logoSrc: companyLogoUrl,
                }),
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default PdfPreviewModal;
export { PdfPreviewModal };
